import { useFeatureFlag } from './use-feature-flag';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';

export const useEnableExtraAutomationPlaybooks = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableExtraAutomationPlaybooks);
};
